export default __webpack_public_path__ + "static/media/SD-kalyanotsavam-img.8b2574bb.png";